module.exports = __webpack_public_path__ + "static/media/ElectionTracker_1.cede09a4.png";